// material-ui
import { useTheme } from '@mui/material/styles';

// ==============================|| LPG PORTAL LOGO SVG ||============================== //

export default function LogoMain() {
  const theme = useTheme();

  return (
    <svg width="140" height="36" viewBox="0 0 140 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Cylinder */}
      <rect
        x="2"
        y="6"
        width="26"
        height="24"
        rx="4"
        fill={theme.vars.palette.primary.main}
      />
      <rect
        x="8"
        y="2"
        width="14"
        height="6"
        rx="2"
        fill={theme.vars.palette.primary.dark}
      />

      {/* Flame */}
      <path
        d="M15 12C12.5 15 11 17 11 19.5C11 22.5 13.2 25 15 25C16.8 25 19 22.5 19 19.5C19 17 17.5 15 15 12Z"
        fill={theme.vars.palette.warning.main}
      />

      {/* Text: LPG */}
      <text
        x="38"
        y="22"
        fontSize="18"
        fontWeight="700"
        fill={theme.vars.palette.text.primary}
        fontFamily='"Sofia Sans", sans-serif'
      >
        LPG
      </text>

      {/* Text: Portal */}
      <text
        x="72"
        y="22"
        fontSize="13"
        fontWeight="500"
        fill={theme.vars.palette.text.secondary}
        fontFamily='"Sofia Sans", sans-serif'
      >
        Portal
      </text>
    </svg>
  );
}
